import React from 'react';
import { aboutContent, team } from '../data/mockData';
import { Award, Heart, Shield, Users } from 'lucide-react';

const APropos = () => {
  return (
    <div>
      {/* Hero Section */}
      <section 
        style={{
          position: 'relative',
          height: '50vh',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          background: 'var(--bg-secondary)'
        }}
      >
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/a56q7pdu_AEA14279-178E-4532-A2F6-BCAE4367663D.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.5)'
          }}
        />
        
        <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-large" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
            À Propos
          </h1>
          <p className="body-large" style={{ color: 'var(--bg-primary)' }}>
            L'histoire de Nina Care Institut
          </p>
        </div>
      </section>

      {/* Notre Histoire */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              {aboutContent.title}
            </h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
              {aboutContent.description}
            </p>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              {aboutContent.mission}
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: window.innerWidth >= 768 ? 'repeat(2, 1fr)' : '1fr',
            gap: '32px',
            marginTop: '60px'
          }}>
            {aboutContent.values.map((value, index) => {
              const icons = [Award, Heart, Shield, Users];
              const Icon = icons[index];
              
              return (
                <div 
                  key={index}
                  style={{
                    padding: '32px',
                    border: '1px solid var(--border-light)',
                    borderRadius: '0px',
                    background: 'var(--bg-primary)'
                  }}
                >
                  <div style={{ 
                    width: '56px', 
                    height: '56px', 
                    borderRadius: '0px',
                    border: '1px solid #C9A961',
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    marginBottom: '20px'
                  }}>
                    <Icon size={28} color="#C9A961" />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                    {value.title}
                  </h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Notre Équipe */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
              Notre Équipe
            </h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Des professionnelles passionnées à votre service
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: window.innerWidth >= 768 ? 'repeat(2, 1fr)' : '1fr',
            gap: '48px',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            {team.map((member) => (
              <div 
                key={member.id}
                style={{
                  textAlign: 'center',
                  padding: '32px',
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px'
                }}
              >
                <div 
                  style={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    background: 'var(--bg-secondary)',
                    border: '2px solid #C9A961',
                    margin: '0 auto 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '48px',
                    fontWeight: 400,
                    color: '#C9A961'
                  }}
                >
                  {member.name.charAt(0)}
                </div>
                <h3 className="heading-2" style={{ marginBottom: '8px' }}>
                  {member.name}
                </h3>
                <p className="body-regular" style={{ color: '#C9A961', marginBottom: '16px', fontWeight: 700 }}>
                  {member.role}
                </p>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
                  {member.description}
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
                  {member.specialties.map((specialty, idx) => (
                    <span 
                      key={idx}
                      className="body-small"
                      style={{
                        padding: '6px 12px',
                        background: 'var(--bg-secondary)',
                        border: '1px solid var(--border-light)',
                        borderRadius: '0px',
                        color: 'var(--text-secondary)'
                      }}
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding-small" style={{ background: 'var(--bg-primary)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            Envie de nous rencontrer ?
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Prenez rendez-vous et découvrez notre univers dédié à votre bien-être
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a 
              href="https://www.planity.com/nina-care-institut-91360-villemoisson-sur-orge" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Prendre rendez-vous
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default APropos;
